export default __webpack_public_path__ + "static/media/sol.9798b790.svg";